import { createApp } from "vue";
// 引入路由
import { router } from "./router";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import App from "./App";
import { store } from "./store";
import "@/assets/style/index.css";

const app = createApp(App);
app.use(router);
app.use(ElementPlus);
app.use(store);
app.mount("#app");
